import { IMemberFieldSchema } from '../CommunityServiceInterface';

export interface IMemberFieldSchemasById {
  [schemaId: string]: IMemberFieldSchema;
}
